export default __webpack_public_path__ + "assets/a6e7e0.svg";